import React, { Component } from "react";

import * as XLSX from "xlsx";
import * as XLSXSH from "sheetjs-style";
import * as FileSaver from "file-saver";
import { toast } from "react-toastify";
import { Button } from "react-bootstrap";
import { generatePlateMap } from "../../../actions/chemistry";
import Loading from "../../../assets/images/loading.gif";
import "./Chemistry.css";

const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".xlsx";

export default class PlatemapButton extends Component {
  loading = (load = true) => {
    if (load) {
      document.body.classList = "ajax-loading";
    } else {
      document.body.classList = "";
    }
  }

  plateMapExcel = (dlist) => {
    const emptyRow = {
      0: "",
      1: "",
      2: "",
      3: "",
      4: "",
      5: "",
      6: "",
      7: "",
      8: "",
      9: "",
      10: "",
      11: "",
      12: "",
      13: "",
    };
    const emptyRowH = {
      1: "",
      2: "",
      3: "",
      4: "",
      5: "",
      6: "",
      7: "",
      8: "",
      9: "",
      10: "",
      11: "",
      0: "H",
      12: "",
      13: "H",
    };
    const columnNumbers = {
      0: "0",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      13: "13",
    };

    const newXl = [];

    const z = dlist.length;

    let k = 1;

    for (let i = 0; i < z;) {
      if ((i + k) % 8 === 0) {
        newXl.push(emptyRowH);
        newXl.push(columnNumbers);
        newXl.push(emptyRow);
        if (i < dlist.length - 1) {
          newXl.push(columnNumbers);
        }
        k++;
      } else {
        newXl.push(dlist[i]);
        i++;
      }
    }

    newXl.push(emptyRowH);
    newXl.push(columnNumbers);

    const head = newXl[8];

    const ws = XLSX.utils.json_to_sheet(newXl);

    let flag = false;
    for (let j = 1; j < newXl.length;) {
      let pos = 0;
      Object.entries(head).forEach(() => {
        const col = String.fromCharCode(65 + pos) + j;
        ws[col].s = {
          fill: {
            patternType: "solid",
            fgColor: { rgb: "808080" },
            bgColor: { rgb: "FFFFFF00" },
          },
        };
        pos++;
      });

      if (flag === false) {
        j += 9;
        flag = true;
      } else {
        j += 2;
        flag = false;
      }
    }

    let pos = 0;

    Object.entries(head).forEach(() => {
      const col = String.fromCharCode(65 + pos) + (newXl.length + 1);
      ws[col].s = {
        fill: {
          patternType: "solid",
          fgColor: { rgb: "808080" },
          bgColor: { rgb: "FFFFFF00" },
        },
      };
      pos++;
    });
    let counter = 1;
    for (let i = 1; i < newXl.length; i++) {
      if (counter === 10) {
        i += 2;
        counter = 1;
      }
      counter++;

      const col = String.fromCharCode(65) + i;
      ws[col].s = {
        fill: {
          patternType: "solid",
          fgColor: { rgb: "808080" },
          bgColor: { rgb: "FFFFFF00" },
        },
      };
    }
    let counter1 = 1;
    for (let i = 1; i < newXl.length; i++) {
      if (counter1 === 10) {
        i += 2;
        counter1 = 1;
      }
      counter1++;
      const col = String.fromCharCode(78) + i;
      ws[col].s = {
        fill: {
          patternType: "solid",
          fgColor: { rgb: "808080" },
          bgColor: { rgb: "FFFFFF00" },
        },
      };
    }

    const lastHL = String.fromCharCode(65) + newXl.length;

    ws[lastHL].s = {
      fill: {
        patternType: "solid",
        fgColor: { rgb: "808080" },
        bgColor: { rgb: "FFFFFF00" },
      },
    };

    const lastHR = String.fromCharCode(78) + newXl.length;

    ws[lastHR].s = {
      fill: {
        patternType: "solid",
        fgColor: { rgb: "808080" },
        bgColor: { rgb: "FFFFFF00" },
      },
    };
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSXSH.write(wb, {
      bookType: "xlsx",
      type: "array",
      cellStyles: "true",
    });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, `Platemap${fileExtension}`);
  };

  plateMap = async () => {
    this.loading();
    const result = await generatePlateMap();

    if (result && result.success) {
      this.loading(false);
      if (result.list) {
        const len = result.list[0].List.length;

        const total = len + (len % 8);

        const dlist = [];
        const rowVal = ["A", "B", "C", "D", "E", "F", "G"];
        let k = 0;
        for (let i = 1; i <= total; i += 12) {
          if (k === 7) {
            k = 0;
          }
          const slist = new Map();
          slist[0] = rowVal[k];

          for (let j = 1; j <= 12; j++) {
            if (i - 1 + j >= len) {
              slist[j] = "";
            } else {
              slist[j] = result.list[0].List[i - 1 + j][0].substring(
                2,
                result.list[0].List[i - 1 + j][0].length,
              );
            }
          }
          slist[13] = rowVal[k];
          k++;
          dlist.push(slist);
        }
        const extra = dlist.length % 7;
        if (extra !== 0) {
          for (let i = 0; i < 7 - extra; i++) {
            // const emptyRow = new Object();
            const emptyRow = {};
            emptyRow[0] = rowVal[i + extra];
            emptyRow[13] = rowVal[i + extra];
            dlist.push(emptyRow);
          }
        }
        this.plateMapExcel(dlist);
      }
    } else {
      toast.error("Empty Excel");
      this.loading(false);
    }
  };

  render() {
    return (
      <div>

        <Button className="chemTabGeneratePlateMap" onClick={this.plateMap}>
          Generate PlateMap
        </Button>

        <div className="overlay">
          <img src={Loading} alt="" />
        </div>
      </div>

    );
  }
}
